module.exports = __webpack_public_path__ + "media/images/post/icon_sns_weibo-6b2cb013aa0944c0e5eda12e39061b43.svg";